export const SLIDER_REQUEST = 'SLIDER_REQUEST';
export const SLIDER_COMMIT = 'SLIDER_COMMIT';
export const SLIDER_SUCCESS = 'SLIDER_SUCCESS';
